import React, { useState, useEffect } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Switch,
    Typography,
} from '@mui/material';
import { getAllBlockedIPs, unblockIP, blockIP, getBlockedIPs } from '../../services/clicks';
import Loading from './Loading';
import { useTranslation } from 'react-i18next';

function AllBlockedIPsList({ user }) {

    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null); 
    const [blockedIPs, setBlockedIPs] = useState([]);
    const [myBlockedIPs, setMyBlockedIPs] = useState([]);

    const [page, setPage] = useState(0); // Pagination: current page
    const [rowsPerPage, setRowsPerPage] = useState(10); // Pagination: rows per page

    const loadIPs = async () => {
        setError(null);
        setIsLoading(true);
        try {
            const { blockedIPs } = await getAllBlockedIPs()
            const { blockedIPs: myBlockedIPs } = await getBlockedIPs(user._id)
            setBlockedIPs(blockedIPs);
            setMyBlockedIPs(myBlockedIPs.map(ip => ip.ip));
        } catch (error) {
            setError(t('ip_blacklist_generic_error'));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadIPs();
    }, []);

    // Handle Pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box>
            <Typography 
                variant="subtitle1" 
                sx={{ margin: 2, textAlign: "center" }}>
                {t('ip_blacklist_blocked_by_community')}
            </Typography>

            {/* Table Section */}
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f5f5f5'}}>
                            <TableCell sx={{fontWeight: 'bold'}}>IP</TableCell>
                            <TableCell sx={{fontWeight: 'bold'}}>{t('ip_blacklist_region')}</TableCell>
                            <TableCell sx={{fontWeight: 'bold'}}>{t('ip_blacklist_is_blocked')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {blockedIPs
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((entry) => {
                                const ipInfo = entry.info || {};
                                const isBlocked = myBlockedIPs.includes(ipInfo?.ip);
                                return (
                                    (
                                        <TableRow key={ipInfo?.ip}>
                                            <TableCell sx={{ color: isBlocked ? 'red': 'black', fontSize: {xs: 14, md: 14} }}>{ipInfo?.location?.country?.emoji || " "}{" " + ipInfo?.ip || "N/A"}</TableCell>
                                            <TableCell sx={{ color: isBlocked ? 'red': 'black', fontSize: {xs: 14, md: 14} }}>{ipInfo?.location?.region?.name || "N/A"}</TableCell>
                                            <TableCell>
                                            <Switch
                                                checked={isBlocked}
                                                onChange={async () => { 
                                                    isBlocked 
                                                    ? await unblockIP(ipInfo?.ip, user._id) 
                                                    : await blockIP(ipInfo?.ip, user._id)
                                                    loadIPs();
                                                }}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                            </TableCell>
                                        </TableRow>
                                    )
                                )
                            })}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination Controls */}
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={blockedIPs.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        
        <Loading 
            text={t('ip_blacklist_loading')}
            isLoading={isLoading} 
        />
        </Box>
    );
}

export default AllBlockedIPsList;